import Slider from "react-slick";
import "./index.scss";
import { CAROUSEL_INFOS } from "./utils/constants";
import { useState } from "react";

export const FeaturedNews = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const options = {
    arrows: false,
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    dotsClass: "thumbnail-list",
    beforeChange: (_, current) => setCurrentSlide(current),
    appendDots: (dots) => (
      <div>
        <ul className="slick-thumb"> {dots} </ul>
      </div>
    ),
    customPaging: function (i) {
      return (
        <div className="custom-dots">
          <img
            width="504"
            height="60"
            loading="lazy"
            src={CAROUSEL_INFOS[i]?.image}
            alt={CAROUSEL_INFOS[i]?.by}
          />
        </div>
      );
    }
  };

  return (
    <section className="featured-news-container">
      <h3 className="featured-title">FEATURED IN THE NEWS</h3>
      <div className="featured-news-slider">
        <Slider {...options}>
          {CAROUSEL_INFOS.map((item) => {
            return (
              <p className="news-quote" key={item.by}>
                &#8220;{item.text}&#8221;{" "}
                <span className="news-author"> - {item.by}</span>
              </p>
            );
          })}
        </Slider>
      </div>
      <div className="mobile-thumbnail-list">
        <div className="custom-dots">
          <img
            width="504"
            height="60"
            loading="lazy"
            src={CAROUSEL_INFOS[currentSlide]?.image}
            alt={CAROUSEL_INFOS[currentSlide]?.by}
          />
        </div>
      </div>
    </section>
  );
};
